import HttpAlignedError from './http-aligned-error.js';

export default class NotFoundError extends HttpAlignedError {
  constructor(message: string, errorCode?: string) {
    super(404, message, errorCode);
    Object.setPrototypeOf(this, NotFoundError.prototype);
  }

  static throwIfNil<T>(
    value: T | null | undefined,
    message = 'Not found',
    errorCode = undefined,
  ): T {
    if (value === null || value === undefined) {
      throw new NotFoundError(message, errorCode);
    }
    return value;
  }
}
